<template>
  <div class="Cta">
    <div class="CtaContent">
      <div class="CtaTitleSecondary">
        Prepare for a technical interview
      </div>
      <h1 class="CtaTitle">
        Get hired with our <br />
        tech interview <span>questions &amp; answers</span>
      </h1>
      <button @click="handleClick" class="CtaButton btn">
        See all questions
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Cta',
  methods: {
    handleClick() {
      const position = document.querySelector('.Hero').offsetHeight - 140;
      window.scrollTo({ top: position, behavior: 'smooth' });
    },
  },
};
</script>

<style lang="scss" scoped>
.Cta {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 150px 0;
  background: url('../assets/img/cta_bg.svg') no-repeat center;
  background-size: cover;
  background-color: $color-background-dark;
}
.CtaContent {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .CtaTitleSecondary {
    font-weight: 400;
    font-size: 21px;
    color: $color-white;
    line-height: 1.5;
    margin-bottom: 30px;
  }
  .CtaTitle {
    width: 100%;
    max-width: 800px;
    margin: 0 auto 30px;
    font-weight: 700;
    font-size: 48px;
    text-align: center;
    color: $color-white;
    br {
      display: none;
    }
    span {
      display: block;
      color: $color-purple;
      background: -webkit-linear-gradient(#e58aeb, #4f85ee);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .CtaButton {
    border: 1px solid $color-white;
    background: none;
    color: $color-white;
    transition: all 0.2s ease-out;
    &:hover {
      color: $color-purple;
      background: $color-white;
      transition: all 0.2s ease-out;
    }
  }
}
@media screen and (max-width: 1000px) {
  .CtaContent {
    .CtaTitle {
      font-size: 35px;
      width: 100%;
      max-width: 100%;
    }
  }
}

@media screen and (max-width: 650px) {
  .Cta {
    padding: 80px 10px;
  }
  .CtaContent {
    .CtaTitleSecondary {
      font-size: 16px;
      text-align: center;
      width: 90%;
    }
    .CtaTitle {
      font-size: 30px;
      br {
        display: block;
      }
    }
  }
  .CtaButton {
    width: 200px;
    font-size: 15px;
  }
}
</style>
